import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

import { getAllGimsUserPositions } from "../../actions";

import {
  API_GIMS_USER_POSITION,
  API_GIMS_USER_POSITION_CREATE,
  API_GIMS_USER_POSITION_UPDATE,
  MAIN_URL,
  PORT_FOR_AUTH,
} from "../../../constants/constants";
import { GET_GIMS_USER_POSITION, SAVE_POSITION_ERROR, SAVE_POSITION_NO_ERROR } from "../../types";

export function getPosition(id) {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GIMS_USER_POSITION + id);

    const data = await response.json();

    dispatch({
      type: GET_GIMS_USER_POSITION,
      data: data,
    });
  };
}

export function createPosition(data) {
  return async (dispatch) => {
    const res = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GIMS_USER_POSITION_CREATE, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.ok) {
      dispatch(getAllGimsUserPositions());
      dispatch({
        type: SAVE_POSITION_NO_ERROR,
        data: "Успешно добавлено",
      });
    } else {
      const dataErr = await res.json().then((data) => data.message);
      dispatch({
        type: SAVE_POSITION_ERROR,
        data: dataErr,
      });
    }
  };
}

export function updatePosition(id, data) {
  return async (dispatch) => {
    const res = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_GIMS_USER_POSITION_UPDATE + id, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (res.ok) {
      dispatch(getAllGimsUserPositions());
      dispatch({
        type: SAVE_POSITION_NO_ERROR,
        data: "Изменения успешно сохранены",
      });
    } else {
      const dataErr = await res.json().then((data) => data.message);
      dispatch({
        type: SAVE_POSITION_ERROR,
        data: dataErr,
      });
    }

    dispatch(getAllGimsUserPositions());
  };
}
